import {useCallback, useMemo} from "react";
import {ImportType} from "@ots-frontend/ots-data";
import {BaseSelect, BaseSelectProps} from "./base-select";

export type ImportTypeSelectProps = Omit<BaseSelectProps, "defaultValue" | "data"> & {
  defaultValue?: ImportType;
  options: ImportType[];
  onImportTypeChange?: (type: ImportType[]) => void;
};

export function ImportTypeSelect(props: ImportTypeSelectProps) {
  const {defaultValue, options, onChange, onImportTypeChange, ...rest} =
    props;

  const _onChange = useCallback(
    (value: string) => {
      if (onImportTypeChange) {
        let items: ImportType[] = [];

        if (value) {
          items = options.filter((o) => o.code === value);
        }

        onImportTypeChange(items);
      }

      if (onChange) {
        onChange(value);
      }
    },
    [options, onChange, onImportTypeChange]
  );

  const data = useMemo(() => {
    return options.map((e) => {
      return {
        value: e.code,
        label: e.name
      };
    });
  }, [options]);

  return (
    <BaseSelect
      data={data}
      onChange={_onChange}
      {...rest} />
  );
}
